import * as getters from '@/store/modules/transfers/requests/international/getters'
import * as mutations from '@/store/modules/transfers/requests/international/mutations'
import * as actions from '@/store/modules/transfers/requests/international/actions'

const state = {
	tmxList: [],
	tmxListHasMore: false,
	tmxCurrencyList: [],
	tmxEstimatedAmount: {},
    tmxNumberOfProcess: []
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
